import { AssortmentSearchPage } from '@features/Assortments/Search/AssortmentSearchPage'
import { assortmentSearchSchema } from '@services/queryOptions'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/assortment/search')({
  validateSearch: assortmentSearchSchema,
  loaderDeps: ({ search }) => search,
  component: AssortmentSearchPage,
  staticData: {
    breadcrumb: 'Sortimentadministrasjon',
  },
})
